




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showReceptionIframe: true,
		};
	},
	computed: {
		wmsJobControllerUrl() {
			return `${this.dmsSys.DMSC_url}/wms/WmsJobController`;
		},
	},
});
